import { Record } from 'immutable';
import _ from 'lodash'
export const TYPE_DEFAULT = 1;
export const TYPE_SYSTEM = 3;
export const TYPE_BOT = 4;

export const ATTACHMENT_TYPE_IMAGE = 1;
export const ATTACHMENT_TYPE_FILE = 2;
export const ATTACHMENT_TYPE_VIDEO = 7;
export const ATTACHMENT_TYPE_AUDIO = 9;
export const ATTACHMENT_TYPE_LOCATION = 3;
export const ATTACHMENT_TYPE_CONTACT = 4;
export const ATTACHMENT_TYPE_CARDS = 5;
export const ATTACHMENT_TYPE_EMBED = 6;

const defaultValues = { id: null, type: 1, message: "", image: null, info: null, user: null, chat_message_attachments: []};

export class MessageRecord extends Record(defaultValues) {
    getIsIncome() {
        return this.user ||  this.type === TYPE_BOT || this.getIsSystem();
    }

    getIsSystem() {
        return this.type === TYPE_SYSTEM
    }

    getIsOutcome() {
        return !this.getIsIncome();
    }


    get buttons() {
        return _.get(this.info, ['buttons']);
    }

    get templateButtons() {
        return _.get(this.info, ['templateButtons']);
    }

    get cards() {
        return _.get(this.info, ['cards'])
    }

    get images() {
        return _.filter(this.chat_message_attachments, {type: ATTACHMENT_TYPE_IMAGE})
    }

    get audio() {
        return _.filter(this.chat_message_attachments, {type: ATTACHMENT_TYPE_AUDIO})
    }

    get files() {
        return _.filter(this.chat_message_attachments, {type: ATTACHMENT_TYPE_FILE})
    }

    get videos() {
        return _.filter(this.chat_message_attachments, {type: ATTACHMENT_TYPE_VIDEO})
    }
    get embed() {
        return _.filter(this.chat_message_attachments, {type: ATTACHMENT_TYPE_EMBED})
    }

}



// WEBPACK FOOTER //
// ./data/MessageRecord.js